module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/vue-wechat-jssdk-195.vue");


//////////////////
// WEBPACK FOOTER
// ./en/wechat/vue-wechat-jssdk.md
// module id = 626
// module chunks = 213